exports = module.exports = require("../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".cloud-foundry-radio-button {\n  margin-left: 20px;\n  padding-left: 20px;\n  padding-right: 20px;\n}\n.cloud-foundry-input {\n  margin-left: 15px;\n}\n.cloud-foundry-checkbox input[type='checkbox'] {\n  margin-left: -5px;\n  margin-top: 9px;\n}\n", ""]);

